var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibilityFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 16.2q1.748 0 2.972-1.225T16.196 12t-1.224-2.975T12 7.8 9.028 9.025 7.804 12t1.224 2.975T12 16.2m0-1.68q-1.05 0-1.783-.735A2.43 2.43 0 0 1 9.483 12q0-1.05.734-1.785A2.43 2.43 0 0 1 12 9.48q1.05 0 1.783.735.735.735.735 1.785t-.735 1.785q-.735.735-1.783.735M12 19q-3.123 0-5.7-1.68a12.07 12.07 0 0 1-4.067-4.433 1.782 1.782 0 0 1-.175-1.342q.059-.222.175-.432A12.07 12.07 0 0 1 6.301 6.68Q8.877 5 12 5t5.7 1.68a12.07 12.07 0 0 1 4.067 4.433q.117.21.175.432a1.8 1.8 0 0 1 0 .91 1.9 1.9 0 0 1-.175.432 12.07 12.07 0 0 1-4.068 4.433Q15.123 19 12 19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilityFill);
export default __webpack_public_path__ + "static/media/visibility_fill.4630c069814fc5568c1af6701e4149b9.svg";
export { ForwardRef as ReactComponent };